import { Cursor } from 'animal-island-ui';
import { useAppStore } from './store/useAppStore';
import Onboarding from './components/Onboarding';
import MainInterface from './components/MainInterface';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  const { stage } = useAppStore();

  return (
    <ErrorBoundary>
      <Cursor forceAll={false}>
        <div id="app" className="h-screen overflow-hidden">
          {stage === 'onboarding' && <Onboarding />}
          {stage === 'main' && <MainInterface />}
        </div>
      </Cursor>
    </ErrorBoundary>
  );
}

export default App;
